// Service configuration constants for Netta website

export const SERVICE_KEYS = [
    'hr',
    'project',
    'crm',
    'document',
    'learning',
    'workflow',
    'forms',
    'chat',
    'reporting'
]

export const SERVICE_CONFIG = {
    hr: {
        key: 'hr',
        icon: 'users',
        color: '#E65100',
        path: '/services/hr'
    },
    project: {
        key: 'project',
        icon: 'briefcase',
        color: '#1E3A5F',
        path: '/services/project'
    },
    crm: {
        key: 'crm',
        icon: 'user-check',
        color: '#2E7D32',
        path: '/services/crm'
    },
    document: {
        key: 'document',
        icon: 'folder',
        color: '#1565C0',
        path: '/services/document'
    },
    learning: {
        key: 'learning',
        icon: 'book-open',
        color: '#7B1FA2',
        path: '/services/learning'
    },
    workflow: {
        key: 'workflow',
        icon: 'git-branch',
        color: '#00838F',
        path: '/services/workflow'
    },
    forms: {
        key: 'forms',
        icon: 'file-text',
        color: '#EF6C00',
        path: '/services/forms'
    },
    chat: {
        key: 'chat',
        icon: 'message-circle',
        color: '#5E35B1',
        path: '/services/chat'
    },
    reporting: {
        key: 'reporting',
        icon: 'bar-chart-2',
        color: '#C62828',
        path: '/services/reporting'
    }
}

// Service images mapping
export const SERVICE_IMAGES = {
    hr: require('../assets/images/illustrator/working_with_computer.svg').default,
    project: require('../assets/images/illustrator/Startup_SVG.svg').default,
    crm: require('../assets/images/illustrator/Marketing_strategy_SVG.svg').default,
    document: require('../assets/images/illustrator/services.svg').default,
    learning: require('../assets/images/illustrator/app_development_SVG.svg').default,
    workflow: require('../assets/images/illustrator/development.svg').default,
    forms: require('../assets/images/illustrator/email-capture.svg').default,
    chat: require('../assets/images/illustrator/social.svg').default,
    reporting: require('../assets/images/illustrator/analyze_report_4.svg').default
}

// Brand colors
export const BRAND_COLORS = {
    primary: '#E65100',
    secondary: '#1E3A5F',
    dark: '#0D1F33',
    success: '#2E7D32',
    info: '#1565C0',
    warning: '#EF6C00',
    danger: '#C62828'
}

// Contact information
export const CONTACT_INFO = {
    phone: '+90 537 505 79 25',
    email: 'info@nettasoftware.com',
    address: 'Ankara, Türkiye',
    workingHours: {
        weekdays: '09:00 - 18:00',
        saturday: '10:00 - 14:00',
        sunday: 'Kapalı'
    }
}

// Company statistics
export const COMPANY_STATS = {
    users: 5000,
    organizations: 50,
    experience: 10,
    satisfaction: 98
}
